import { render, staticRenderFns } from "./ReasonModal.vue?vue&type=template&id=86c32086&"
import script from "./ReasonModal.vue?vue&type=script&lang=js&"
export * from "./ReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports